import force_configuration from "~/helpers/shared/profile/force"

export default {
  data() {
    return {
      config: {
        influencer: [
          {
            fnKey: "str_length",
            key: "entity",
            score: 10,
          },
          {
            fnKey: "str_length",
            key: "description",
            score: 10,
          },
          {
            fnKey: "array_length",
            key: "preferences",
            score: 10,
          },
          {
            fnKey: "array_length",
            key: "rejections",
            score: 10,
          },
          {
            fnKey: "array_length",
            key: ["tags", "identity", "country"],
            name: "country",
            score: 10,
          },
          {
            fnKey: "array_length",
            key: ["tags", "liked", "subgenre"],
            name: "genre",
            score: 15,
          },
          ...force_configuration,
        ],
        band: [
          {
            fnKey: "str_length",
            key: "name",
            score: 10,
          },
          {
            fnKey: "str_length",
            key: "country",
            score: 10,
          },
          {
            fnKey: "array_length",
            key: "genres",
            score: 10,
          },
          {
            fnKey: "boolean",
            key: "has_profile_picture",
            score: 20,
          },
          {
            fnKey: "str_length",
            key: "biography",
            score: 10,
          },
          {
            fnKey: "str_length",
            key: "news",
            score: 10,
          },
          ...force_configuration,
        ],
      },
    }
  },
  computed: {
    mediaLinksForce() {
      const media_links = this.entity.media_links
      let i = 0

      for (var key in media_links) {
        if (media_links[key] !== null && media_links[key].length) i++
      }
      return i ? (i < 4 ? 10 : 0) : 20
    },
    selectedConfig() {
      return this.config[this.kind]
    },
    missingForces() {
      const ret = []

      for (
        var configIndex = 0;
        configIndex < this.selectedConfig.length;
        configIndex++
      ) {
        const compareElement = this.selectedConfig[configIndex]
        const compareData = this.dereferenceData(
          this.entity,
          compareElement.key
        )
        const compareFn = this[`evaluate_${compareElement.fnKey}`]

        if (typeof compareFn === "function" && compareFn(compareData) === false)
          ret.push({
            name: compareElement.name || compareElement.key,
            score: this.selectScore(compareElement),
          })
      }

      return ret
    },
    missingForce() {
      if (this.missingForces.length) {
        const scoreArr = this.missingForces.map((e) => e.score)
        const missing = scoreArr.reduce((acc, val) => acc + val, 0)
        const mlf = this.mediaLinksForce

        return missing + mlf
      } else return 0
    },
    force() {
      return 100 - this.missingForce
    },
    messageKey() {
      if (this.missingForces.length) return this.missingForces[0].name
      return ""
    },
  },
  methods: {
    dereferenceData(object, key) {
      if (typeof key === "string") return object[key]
      else if (key.length && object)
        return this.dereferenceData(object[key[0]], key.slice(1))
      else if (object) return object
      else return null
    },
    selectScore: function (compareElement) {
      const score = compareElement.score

      if (typeof score === "number") return score
      else return score[this.kind]
    },
    evaluate_str_length: function (str) {
      return typeof str === "string" && str.length > 0
    },
    evaluate_boolean: function (boolean) {
      return typeof boolean === "boolean" && boolean
    },
    evaluate_array_length: function (array) {
      return (typeof array === "object" && array?.length) > 0 ?? false
    },
  },
  props: {
    kind: {
      type: String,
      required: true,
      validator: function (value) {
        return ["influencer", "band"].includes(value)
      },
    },
    entity: {
      type: Object,
      required: true,
    },
  },
}
